import * as Sentry from '@sentry/nextjs';

import { INTERNAL_MESSAGE_SOURCE } from './constants';
import { InternalMessage } from './types';

export const sendMessageToEmbed = (message: InternalMessage): boolean => {
    try {
        const target = window.parent;
        if (!target) throw new Error('window.parent not available');
        target.postMessage(
            { ...message, source: INTERNAL_MESSAGE_SOURCE },
            { targetOrigin: '*' }
        );
        return true;
    } catch (err) {
        Sentry.captureException(err, {
            extra: { context: 'internal-message', message },
        });
        return false;
    }
};
